import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDollarSerif = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(3.75 0) scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.416 10.128C2.43733 11.024 2.64533 11.6853 3.04 12.112C3.44533 12.5387 4.10133 12.784 5.008 12.848V8.368L4 8.16C3.15733 7.97867 2.50667 7.62133 2.048 7.088C1.58933 6.55467 1.36 5.88267 1.36 5.072C1.36 4.112 1.67467 3.35467 2.304 2.8C2.944 2.23467 3.84533 1.92 5.008 1.856V0.559999H6.08V1.856C7.28533 1.952 8.20267 2.32533 8.832 2.976C9.46133 3.616 9.77067 4.48533 9.76 5.584H8.288C8.288 4.112 7.552 3.30667 6.08 3.168V7.168L7.296 7.424C9.184 7.81867 10.128 8.88 10.128 10.608C10.128 11.696 9.78133 12.5387 9.088 13.136C8.40533 13.7333 7.40267 14.0693 6.08 14.144V15.456H5.008V14.144C3.64267 14.0693 2.61867 13.7013 1.936 13.04C1.264 12.368 0.933333 11.3973 0.944 10.128H2.416ZM2.864 5.024C2.864 5.54667 3.024 5.95733 3.344 6.256C3.67467 6.55467 4.20267 6.77867 4.928 6.928L5.008 6.944V3.152C3.57867 3.26933 2.864 3.89333 2.864 5.024ZM6.08 12.848C6.95467 12.7947 7.59467 12.592 8 12.24C8.416 11.888 8.624 11.3653 8.624 10.672C8.624 10.096 8.464 9.664 8.144 9.376C7.824 9.07733 7.25867 8.84267 6.448 8.672L6.08 8.592V12.848Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgDollarSerif);
export default ForwardRef;
